import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form, Col } from "react-bootstrap";
import AdvancedSelect from "controls/advancedSelect";
import RefundRequestViewModel from "../../../viewModels/notice/refundRequest/refundRequestViewModel";
import { Input } from "@frui.ts/bootstrap";
import CustomerRefundApplicationReason from "../../../entities/customerRefundApplicationReason";

const RefundReasonSelect: FunctionComponent<{
  vm: RefundRequestViewModel;
}> = observer(({ vm }) => {
  const labelId = "refund-reason-label";
  const otherLabelId = "refund-reason-other-label";

  return (
    <>
      <Form.Row>
        <Form.Group as={Col} sm={12}>
          <Form.Label id={labelId}>{vm.translateAttribute("reason")}</Form.Label>
          <AdvancedSelect
            target={vm.notice}
            property="reason"
            items={vm.reasons}
            isSearchable={false}
            aria-labelledby={labelId}
            mode="key"
            formatOptionLabel={(data: any) => {
              return <span dangerouslySetInnerHTML={{ __html: data.label }} />;
            }}
          />
        </Form.Group>
      </Form.Row>
      {vm.notice.reason === CustomerRefundApplicationReason.Other && (
        <Form.Row>
          <Form.Group as={Col} sm={12}>
            <Form.Label id={otherLabelId}>{vm.translateAttribute("otherReasonText")}</Form.Label>
            <Input target={vm.notice} property="otherReasonText" required aria-labelledby={otherLabelId} maxLength={500} />
          </Form.Group>
        </Form.Row>
      )}
    </>
  );
});

export default RefundReasonSelect;
